import FinancialAmount, {
  type FinancialAmountProps,
} from "@/pages/(app)/returns/view/components/financial-card/financial-amount";

interface FinancialAmountSectionProps {
  title: string;
  children: React.ReactElement<FinancialAmountProps>;
}

export default function FinancialSection({
  title,
  children,
}: FinancialAmountSectionProps) {
  if (children.type !== FinancialAmount) {
    throw new Error(
      "FinancialSection only accept FinancialAmount as children.",
    );
  }

  return (
    <div className="flex items-center justify-between pt-4">
      <div className="text-sm">{title}</div>
      <div className="text-sm font-medium text-gray-900">{children}</div>
    </div>
  );
}
